import useAuthUserID from './useAuthUserID';

const useIsLoggedIn = () => {
	return !!useAuthUserID();
};

export default useIsLoggedIn;
